import React from "react";
import { MapPin, Truck, Home } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, WHATSAPP_NUMBER } from "../../config/constants";

const Contact: React.FC = () => {
  return (
    <section
      id="contact"
      className="py-20 md:py-28 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #fff1f2 0%, #fce7f3 50%, #fdf8f0 100%)",
      }}>
      {/* Decorative */}
      <div
        className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle, #fb7185, transparent)" }}
      />

      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 reveal">
          <p className="font-body text-xs text-rose-500 tracking-[0.3em] uppercase font-medium mb-3">
            Encuéntranos
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-rose-900 mb-4">
            ¡Hagamos tu pedido!
          </h2>
          <p className="font-body text-rose-700/70 text-base max-w-md mx-auto">
            Escríbenos por Instagram o WhatsApp y con gusto te asesoramos.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 reveal">
          {/* Instagram */}
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noreferrer"
            className="cake-card bg-white rounded-2xl p-6 border border-rose-100 flex flex-col items-center text-center gap-3 group">
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-md overflow-hidden"
              style={{
                background:
                  "linear-gradient(135deg, #f9a8d4, #fb7185, #e11d48)",
              }}>
              <img
                src="/logotipo-de-instagram.png"
                alt="Instagram"
                className="w-8 h-8 object-contain filter brightness-0 invert"
              />
            </div>
            <div>
              <h3 className="font-display text-lg text-rose-900 font-semibold">
                Instagram
              </h3>
              <p className="font-body text-sm text-rose-500">@{INSTAGRAM_HANDLE}</p>
            </div>
            <span className="text-xs font-body text-rose-400 group-hover:text-rose-600 transition-colors">
              Ver perfil &rarr;
            </span>
          </a>

          {/* WhatsApp */}
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hola! Estef's Cakes, me gustaría hacer un pedido`}
            target="_blank"
            rel="noreferrer"
            className="cake-card bg-white rounded-2xl p-6 border border-rose-100 flex flex-col items-center text-center gap-3 group">
            <div className="w-14 h-14 rounded-2xl flex items-center justify-center shadow-md overflow-hidden bg-emerald-500">
              <img
                src="/whatsapp.png"
                alt="WhatsApp"
                className="w-8 h-8 object-contain filter brightness-0 invert"
              />
            </div>
            <div>
              <h3 className="font-display text-lg text-rose-900 font-semibold">
                WhatsApp
              </h3>
              <p className="font-body text-sm text-rose-500">
                Escríbenos directo
              </p>
            </div>
            <span className="text-xs font-body text-rose-400 group-hover:text-rose-600 transition-colors">
              Chatear &rarr;
            </span>
          </a>

          {/* Location */}
          <a
            href="https://maps.app.goo.gl/43v2XfYjvgkuLoru5"
            target="_blank"
            rel="noreferrer"
            className="cake-card bg-white rounded-2xl p-6 border border-rose-100 flex flex-col items-center text-center gap-3 group sm:col-span-2 lg:col-span-1">
            <div className="w-14 h-14 rounded-2xl bg-rose-600 flex items-center justify-center shadow-md">
              <MapPin className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-display text-lg text-rose-900 font-semibold">
                Ubicación
              </h3>
              <p className="font-body text-sm text-rose-500">
                Pick Up en Puerto La Cruz
              </p>
            </div>
            <p className="font-body text-xs text-rose-400 text-center">
              Ver en Maps &rarr;
            </p>
          </a>
        </div>

        {/* Delivery info */}
        <div className="mt-8 grid sm:grid-cols-2 gap-4 reveal">
          <div className="bg-white/80 border border-rose-100 rounded-2xl p-5 flex items-center gap-4">
            <div className="w-10 h-10 rounded-xl bg-rose-50 flex items-center justify-center flex-shrink-0">
              <Home className="w-5 h-5 text-rose-600" />
            </div>
            <div>
              <p className="font-body font-semibold text-rose-800 text-sm">
                Punto de Retiro (Pick Up)
              </p>
              <p className="font-body text-xs text-rose-500">
                Av. Municipal, Edif. Torre Porteña. Ref: Después del Hotel Cristina Suites, frente al Supermercado Todo Hogar.
              </p>
            </div>
          </div>
          <div className="bg-white/80 border border-rose-100 rounded-2xl p-5 flex items-center gap-4">
            <div className="w-10 h-10 rounded-xl bg-rose-50 flex items-center justify-center flex-shrink-0">
              <Truck className="w-5 h-5 text-rose-600" />
            </div>
            <div>
              <p className="font-body font-semibold text-rose-800 text-sm">
                Delivery
              </p>
              <p className="font-body text-xs text-rose-500">
                Somos una tienda online con punto de Pick Up en Puerto La Cruz. Costo adicional según la zona. Consulta disponibilidad.
              </p>
            </div>
          </div>
        </div>

        {/* Embedded Map Section */}
        <div
          className="mt-8 reveal w-full h-[300px] sm:h-[400px] rounded-2xl overflow-hidden border border-rose-100 shadow-lg"
          style={{ background: "#fff" }}>
          <iframe
            src="https://maps.google.com/maps?q=10.220875389710764,-64.63095271689156&hl=es&z=17&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen={true}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ubicación Estef's Cakes"></iframe>
        </div>
      </div>
    </section>
  );
};

export default Contact;
